import firebase from "firebase";
const mainid = "s416ENLe6cIZilJrnQf0"
const state = {}

const actions = {
	getSettings({commit}){

		var subscription = firebase.firestore().doc(`assessmentDefinitions/${mainid}`).onSnapshot(doc => {
			commit("SET_ALL",  {data: doc.data(), collection: "assessmentSettings"}, {root:true} )
		})
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
	}
} 

const mutations = {
	
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
